<template>
  <div class="row">
    <div class="col s0 m12 l12">
      <div class="row">
        <div class="col s0 m12 l12 global-result__item-label global-result__item-label--course">Curso</div>
      </div>

      <div class="row clickable" @click.prevent="click(course)">
        <span class="col m12 l12 global-result__item-title">
          <span class="global-result__type-icon-wrap global-result__type-icon-wrap--course">
            <i class="material-icons global-result__type-icon">menu_book</i>
          </span>
          {{ course.name }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GlobalSearchResultCourse",
  emits: ["click"],
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  methods: {
    click(module) {
      this.$emit("click", {
        courseId: module.id,
        shopWindowId: module.shopWindowId,
      });
    },
  },
};
</script>
